import Table from './scripts';
import './styles/container.scss';
import './styles/table.scss';

export default Table;
